import { render, staticRenderFns } from "./PayeeMatchConfigImportDialog.vue?vue&type=template&id=52cd0d40&scoped=true&"
import script from "./PayeeMatchConfigImportDialog.vue?vue&type=script&lang=js&"
export * from "./PayeeMatchConfigImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./PayeeMatchConfigImportDialog.vue?vue&type=style&index=0&id=52cd0d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd0d40",
  null
  
)

export default component.exports